import { useSchedulesStore } from "../../stores/useSchedulesStore";
import { useScheduleRoom } from "./useScheduleRoom";
import { useEnsureSchedule } from "./useEnsureSchedule";

const EMPTY = null;

function getScheduleKey(codigo, flagCol) {

    if (!codigo || !flagCol) {
        return null;
    }

    return `schedule:${codigo}-${flagCol}`;

}

export function useSchedule(codigo, flagCol) {


    const redisKey = getScheduleKey(codigo, flagCol);
    
    useScheduleRoom(redisKey);

    useEnsureSchedule(redisKey);

    return useSchedulesStore(state => {

        if (!redisKey) {
            return EMPTY;
        }

        return state.schedules[redisKey] ?? EMPTY;

    });

}